import Login from "../Injaz-LoginScreen/Injaz-LoginScreen.jsx";
import { connect } from 'react-redux';

import { loginThunk } from '../../redux/actions/loginAction.js';

const mapStateToProps = ({user}) => ({
	user
});
// const mapStateToProps = state => {
// 	// return {
// 	//   objects: state.objectIds.map(id => state.objects[id])
// 	// }
// 	return state;
//   }

const mapDispatchToProps = dispatch => ({
    loginThunk: (usernameOrEmail, password) => dispatch(loginThunk(usernameOrEmail, password))
    // ,
	// tokenAuthThunk: () => dispatch(tokenAuthThunk()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
